import {
  scale,
  rotate,
  translate,
  compose,
  applyToPoint,
} from "transformation-matrix";

export const scalePoint = (scaleVal, aroundPoint, point) => {
  const matrix = compose(
    translate(aroundPoint.x, aroundPoint.y),
    scale(scaleVal),
    translate(-1 * aroundPoint.x, -1 * aroundPoint.y)
  );
  return applyToPoint(matrix, {
    x: point.x,
    y: point.y,
  });
};
export const rotatePoint = (rotateVal, aroundPoint, point) => {
  const matrix = compose(
    translate(aroundPoint.x, aroundPoint.y),
    rotate((rotateVal * Math.PI) / 180),
    translate(-1 * aroundPoint.x, -1 * aroundPoint.y)
  );
  return applyToPoint(matrix, {
    x: point.x,
    y: point.y,
  });
};

/**
 * get rect points, untransformed. Pr depends on transform origin, not included
 * @param {Object} layer
 * @returns rect points as {x, y}
 */
export const getPoints = (layer) => ({
  P1: {
    x: layer.xPos,
    y: layer.yPos,
  },
  P2: {
    x: layer.xPos + layer.displayWidth,
    y: layer.yPos,
  },
  P3: {
    x: layer.xPos,
    y: layer.yPos + layer.displayHeight
  },
  P4: {
    x: layer.xPos + layer.displayWidth,
    y: layer.yPos + layer.displayHeight
  }
});

/**
 * get angle of line 2 points make
 * @param {Object} P1 {x, y}
 * @param {Object} P2 {x, y}
 * @returns angle
 */
export const calcAngle = (P1, P2) => {
  return Math.atan((P2.y - P1.y) / (P2.x - P1.x));
}

export const pointDistance = (P1, P2) => {
  const x_sqr = (P2.x - P1.x) ** 2
  const y_sqr = (P2.y - P1.y) ** 2
  return Math.sqrt(x_sqr + y_sqr);
}